const calculateYSegment = (
    latitudeRef: number,
    latitude: number,
    circumference: number
): number => {
    return ((latitude - latitudeRef) * circumference) / 360.0;
};

const calculateXSegment = (
    longitudeRef: number,
    longitude: number,
    latitude: number,
    circumference: number
): number => {
    return (
        ((longitude - longitudeRef) *
            circumference *
            Math.cos(latitude * (Math.PI / 180))) /
        360.0
    );
};

const calculateAreaInSquareMeters = (
    x1: number,
    x2: number,
    y1: number,
    y2: number
): number => {
    return (y1 * x2 - x1 * y2) / 2;
};

export const calculatePolygonArea = (
    locations: {
        latitude: number;
        longitude: number;
    }[]
) => {
    if (!locations.length) {
        return 0;
    }

    if (locations.length < 3) {
        return 0;
    }

    const radius = 6371000;

    const diameter = radius * 2;
    const circumference = diameter * Math.PI;
    const listY = [];
    const listX = [];
    const listArea = [];
    // calculate segment x and y in degrees for each point

    const latitudeRef = locations[0].latitude;
    const longitudeRef = locations[0].longitude;

    for (let i = 1; i < locations.length; i++) {
        const { latitude, longitude } = locations[i];
        listY.push(calculateYSegment(latitudeRef, latitude, circumference));

        listX.push(
            calculateXSegment(longitudeRef, longitude, latitude, circumference)
        );
    }

    for (let i = 1; i < listX.length; i++) {
        const x1 = listX[i - 1];
        const y1 = listY[i - 1];
        const x2 = listX[i];
        const y2 = listY[i];
        listArea.push(calculateAreaInSquareMeters(x1, x2, y1, y2));
    }

    let areasSum = 0;
    listArea.forEach((area) => {
        areasSum += area;
    });

    const areaCalc = Math.abs(areasSum);
    return areaCalc;
};
